module.exports = __webpack_public_path__ + "img/reifenreparatur_heissverfahren_784x514.a3983ae1.jpg";